import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=86b77ff2&scoped=true"
import script from "./RoleDialog.vue?vue&type=script&lang=js"
export * from "./RoleDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleDialog.vue?vue&type=style&index=0&id=86b77ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b77ff2",
  null
  
)

export default component.exports